// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.feature-attributes-body table {
    width: 100%;
}

div.feature-attributes-body table td:first-child {
    width: 25%
}

div.feature-attributes-body table td:last-child {
    width: 1%;
}

div.feature-attributes-body table td > input {
    min-width: 0;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/style/FeatureAttributesWindow.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;AACf","sourcesContent":["div.feature-attributes-body table {\n    width: 100%;\n}\n\ndiv.feature-attributes-body table td:first-child {\n    width: 25%\n}\n\ndiv.feature-attributes-body table td:last-child {\n    width: 1%;\n}\n\ndiv.feature-attributes-body table td > input {\n    min-width: 0;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
